export default __webpack_public_path__ + "d579f2e3aeb4089f7bbf59b389dda04b.png";